import { DIALOG_DATA, DialogRef } from "@angular/cdk/dialog"
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'
import { AuthService } from '../../../_services/auth.service'
import { IParticipant } from '../../../types/request.types'
import { RequestService } from '../request.service'

@Component({
  selector: 'app-request-modal',
  templateUrl: './request-modal.component.html',
  styleUrls: ['./request-modal.component.css']
})
export class RequestModalComponent implements OnInit {
  public tin = '';
  public comment = '';
  public users: IParticipant[] = [];
  public organization;

  public loadingSearchIIN = false;
  public loadingSearchTin = false;
  public loadingAddUser = false;

  public isUserSearchError = false;
  public isMyIin = false;
  public isCompanySearchError = false;
  public iinIsRepeated = false;
  private lastProcessedIIN: string = '';
  private isProcessingIIN: boolean = false;
  private lastSearchTime: number = 0;

  @Input() iin;
  @Input() templateId;
  @Output() toggleRequest = new EventEmitter();


  constructor(
    private requestService: RequestService,
    private authService: AuthService,
    public translate: TranslateService,
    private toastr: ToastrService,
    @Inject(DIALOG_DATA) public data: any,
    public dialogRef: DialogRef<RequestModalComponent>,
  ) {}

  ngOnInit() {
    this.users = [];
    // console.log(this.data.iin)
    // this.data.iin = '';
  }
  initials(fullName: string): string {
    return (fullName || '').trim().split(/\s+/).slice(0, 2).map(w => w.charAt(0)).join('').toUpperCase();
  }

  // 900101300123 → 900101 300123
  shortenName(fullName: string): string {
    const parts = fullName.split(' ');
    if (parts.length === 3) {
      const [surname, name, patronymic] = parts;
      return `${surname} ${name.charAt(0)}. ${patronymic.charAt(0)}.`;
    } else if (parts.length === 2) {
      const [surname, name] = parts;
      return `${surname} ${name.charAt(0)}.`;
    } else {
      return "Error";
    }
  }
  onSearchIIN() {
    const now = Date.now();
    // Защита от повторных вызовов в течение 500ms
    if (now - this.lastSearchTime < 500) {
      return;
    }
    // Защита от повторных вызовов - проверяем в самом начале
    if (this.isProcessingIIN || this.loadingSearchIIN) {
      return;
    }
    if (!this.data.iin || this.data.iin.length !== 12) {
      return;
    }
    // Защита от повторной обработки того же ИИН
    if (this.lastProcessedIIN === this.data.iin) {
      return;
    }
    // Устанавливаем флаги синхронно в самом начале, чтобы заблокировать повторные вызовы
    this.lastSearchTime = now;
    this.isProcessingIIN = true;
    this.lastProcessedIIN = this.data.iin;
    this.loadingSearchIIN = true;
    
    this.isUserSearchError = false;
    this.isMyIin = false;
    this.iinIsRepeated = false;
    
    if (this.users.find((user: IParticipant) => user.iin === this.data.iin)) {
      this.iinIsRepeated = true;
      this.loadingSearchIIN = false;
      this.isProcessingIIN = false;
      this.lastProcessedIIN = '';
      return;
    }
    if (this.authService.user.iin === this.data.iin) {
      this.isMyIin = true;
      this.toastr.error(this.translate.instant('Errors.You can not add yourself'));
      this.loadingSearchIIN = false;
      this.isProcessingIIN = false;
      this.lastProcessedIIN = '';
      return;
    }
    this.requestService.getFullNameFromIIN(this.data.iin)
      .subscribe((res: any) => {
        this.users = [{
            fullName: res.elements[0].name.kk,
            iin: this.data.iin
        }]
        this.loadingSearchIIN = false;
        this.isProcessingIIN = false;
        this.lastProcessedIIN = '';
      },
      error => {
        this.loadingSearchIIN = false;
        this.isProcessingIIN = false;
        this.lastProcessedIIN = '';
        this.toastr.error(this.translate.instant('Errors.NOT_FOUND_IIN'));
      }
    );
  }
  keyPress(event) {
    const regex = new RegExp('^([0-9]{1}|[0-9]{2}|[0-9]{3}|[0-9]{4}|[0-9]{5}|[0-9]{6}|[0-9]{7}|[0-9]{8}|[0-9]{9}|[0-9]{10}|[0-9]{11}|[0-9]{12})$');
    return regex.test(event.key);
  }
  onSearchTIN() {
    this.loadingSearchTin = true;
    this.isCompanySearchError = false;
    this.requestService.getOrganization(this.tin)
    .subscribe(
      (res: any) => {
        this.organization = {
          name: res.elements[0].name,
          tin: this.tin
        };
        this.loadingSearchTin = false;
        this.tin = '';
      },
      error => {
        this.loadingSearchTin = false;
        this.isCompanySearchError = true;
      }
    );
  }
  onClose(){
    this.dialogRef.close();
  }
  sendRequest() {
    this.loadingAddUser = true;
    const data = {
      initiator: this.authService.user.iin,
      acceptors: this.users.map(res => res.iin),
      doc_id: this.data.templateId ? this.data.templateId : this.templateId,
      commentary: this.comment,
      tin: this.organization ? this.organization.tin : ''
    };
    this.requestService.sendRequest(data).subscribe((res: any) => {
      if (res.code === 0) {
        // const requestId = res.result.agreement_id;
        this.loadingAddUser = false;
        this.toastr.success(this.translate.instant('Your request send'));
        this.onClose();
      }
    }, (error: any) => {
      this.loadingAddUser = false;
      const errorText = this.translate.instant(`Errors.${error.error.message}`);
      this.toastr.error(errorText);
    });
  }
  removeUser(user) {
    if (this.users.length > 1) {
      this.users.splice(this.users.indexOf(user), 1);
    } else {
      this.users = [];
    }
  }
  removeOrganization() {
    this.organization = null;
  }
}
